import { Controller, type Control, type FieldPath, type FieldValues } from 'react-hook-form';

import { FieldCategorySelect } from './field-category-select';

interface FormFieldCategorySelectProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof FieldCategorySelect>, 'value' | 'onValueChange' | 'errors'> {
  control: Control<T>;
  name: FieldPath<T>;
}

export function FormFieldCategorySelect<T extends FieldValues>({
  control,
  name,
  ...rest
}: FormFieldCategorySelectProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FieldCategorySelect
          {...rest}
          value={field.value || null}
          onValueChange={(val) => {
            field.onChange(val ?? '');
            field.onBlur();
          }}
          errors={fieldState.error ? [fieldState.error] : undefined}
        />
      )}
    />
  );
}
